import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';

import l from '../../../../lang';

import { Routes } from '../../../../config/routes';

import LinkIcon from '../../../../assets/icons/payment-link-squared.svg';
import PosIcon from '../../../../assets/icons/payment-pos-squared.svg';
import IntegrationIcon from '../../../../assets/icons/payment-integration-squared.svg';
import ArrowRight from '../../../../assets/icons/arrow-right-blue.svg';

import ButtonLink from '../../../common/button-link';
import CardTitle from '../../../common/card-title';
import Card from '../../../common/card';
import CardInfo from '../../../common/card-info';
import { segmentProductMenuCreatePaymentLink, segmentProductMenuSeeIntegrations, segmentProductMenuUseVirtualPos } from '../../../../utils/analytics';

interface ProductCardsProps {
  shouldAnimationsRun: boolean;
}

const ProductCards = ({ shouldAnimationsRun }: ProductCardsProps) => {
  const history = useHistory();

  const onPaymentLinkHandler = () => {
    segmentProductMenuCreatePaymentLink();
    history.push(Routes.CREATE_PAYMENT_LINK);
  }

  const onVirtualPosHandler = () => {
    segmentProductMenuUseVirtualPos();
    history.push(Routes.VIRTUAL_POS);
  }

  const onIntegrationsHandler = () => {
    segmentProductMenuSeeIntegrations();
    history.push(Routes.PAYMENT_INTEGRATION);
  }

  return (
    <Card>
      <CardTitle>{l('home.readyMsg.subtitle')}</CardTitle>
      <div className="products-desc">
        <ButtonLink text={l('home.product.link')} onClick={() => history.push(Routes.PAYMENT_INTEGRATION)} />
        {l('home.product.desc')}
      </div>
      <div className={`three-cards ${shouldAnimationsRun ? 'card__animated' : ''}`}>
        <CardInfo>
          <div className="card__title card__with-icon">
            <img src={LinkIcon} alt="checked" />
            {l('home.product.payment.link')}
          </div>
          <div className="card__desc">{Parser(l('home.product.payment.link.desc'))}</div>
          <div className="card__desc">
            <ButtonLink
              text={
                <div className="card__with-icon">
                  {l('home.product.payment.link.link')}
                  <img src={ArrowRight} className="arrow" />
                </div>
              }
              onClick={onPaymentLinkHandler}
            />
          </div>
        </CardInfo>

        <CardInfo>
          <div className="card__title card__with-icon">
            <img src={PosIcon} alt="checked" />
            {l('home.product.payment.pos')}
          </div>
          <div className="card__desc">{Parser(l('home.product.payment.pos.desc'))}</div>
          <div className="card__desc">
            <ButtonLink
              text={
                <div className="card__with-icon">
                  {l('home.product.payment.pos.link')}
                  <img src={ArrowRight} className="arrow" />
                </div>
              }
              onClick={onVirtualPosHandler}
            />
          </div>
        </CardInfo>

        <CardInfo>
          <div className="card__title card__with-icon">
            <img src={IntegrationIcon} alt="checked" />
            {l('home.product.payment.integration')}
          </div>
          <div className="card__desc">{Parser(l('home.product.payment.integration.desc'))}</div>
          <div className="card__desc">
            <ButtonLink
              text={
                <div className="card__with-icon">
                  {l('home.product.payment.integration.link')}
                  <img src={ArrowRight} className="arrow" />
                </div>
              }
              onClick={onIntegrationsHandler}
            />
          </div>
        </CardInfo>
      </div>
    </Card>
  );
};

export default ProductCards;
